import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AgGridRowsQueryVariables = Types.Exact<{
  gridId: Types.Scalars['String']['input'];
  request: Types.GridRequestInput;
}>;


export type AgGridRowsQuery = { __typename?: 'Query', agGridRows: { __typename?: 'AgGridRowsResult', rowData: Array<unknown>, rowCount?: number | null, unfilteredRowCount?: number | null } };


export const AgGridRowsDocument = new TypedDocumentString(`
    query AgGridRows($gridId: String!, $request: GridRequestInput!) {
  agGridRows(gridId: $gridId, request: $request) {
    rowData
    rowCount
    unfilteredRowCount
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AgGridRows: build.query<AgGridRowsQuery, AgGridRowsQueryVariables>({
      query: (variables) => ({ document: AgGridRowsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAgGridRowsQuery, useLazyAgGridRowsQuery } = injectedRtkApi;
